module.exports = __webpack_public_path__ + "img/111.6.feea0cd4.png";